import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Total runtime of one grain-pulse animation. Consumers that chain
 *  follow-up animations (e.g. card-border flash) read this so timing
 *  stays in lockstep with the canvas component. */
export const GRAIN_PULSE_DURATION_MS = 700;

@Injectable({ providedIn: 'root' })
export class GrainPulseService {
  private readonly pulseSubject = new Subject<void>();
  readonly pulse$ = this.pulseSubject.asObservable();

  pulse(): void {
    this.pulseSubject.next();
  }
}
